import { render, staticRenderFns } from "./UnHoldModel.vue?vue&type=template&id=de647184&scoped=true&"
import script from "./UnHoldModel.vue?vue&type=script&lang=js&"
export * from "./UnHoldModel.vue?vue&type=script&lang=js&"
import style0 from "./UnHoldModel.vue?vue&type=style&index=0&id=de647184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de647184",
  null
  
)

export default component.exports